(function () {
    function focusTarget(el) {
        if (!el) return;
        const nativelyFocusable = /^(a|button|input|select|textarea)$/i.test(el.tagName)
            || el.getAttribute('tabindex') !== null
            || el.getAttribute('role') === 'tab';
        if (!nativelyFocusable) {
            el.setAttribute('tabindex', '-1');
            el.addEventListener('blur', function onBlur() {
                el.removeAttribute('tabindex');
                el.removeEventListener('blur', onBlur);
            });
        }
        el.focus({ preventScroll: true });
    }

    function initLink(link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.getElementById(this.getAttribute('href').slice(1));
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                focusTarget(target);
            }
        });
    }

    function buildAutoNav() {
        const autoNav = document.querySelector('.collection-anchor-nav--auto');
        if (!autoNav || autoNav.dataset.built) return;
        autoNav.dataset.built = 'true';

        const sections = Array.from(
            document.querySelectorAll('.featured-collection[data-anchor-label], .section-rich-text[data-anchor-label]')
        );
        if (sections.length === 0) return;

        sections.forEach((section) => {
            const label = section.dataset.anchorLabel;
            const id = section.id;
            if (!label || !id) return;
            if (section.classList.contains('hidden')) return;

            const link = document.createElement('a');
            link.className = 'collection-anchor-nav__link';
            link.href = '#' + id;
            link.textContent = label;
            autoNav.appendChild(link);
            initLink(link);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', buildAutoNav);
    } else {
        buildAutoNav();
    }
})();
